<template>
  <div class="assessSuccess">
   <!-- <nav-bar title="评价"></nav-bar> -->
	<van-nav-bar
	  title="评价"
	  left-arrow
	   fixed placeholder
	  @click-left="onClickLeft"
	/>
    <van-cell is-link class="project">
      <template #title>
        <span class="number">{{ order.sn }}</span>
        <p class="name">{{ order.projectName }}</p>
        <van-tag color="#FF9500">{{order.workTypeName}}</van-tag>
      </template>
    </van-cell>
   <!-- <div class="order">
      <div>下单人</div>
      <div class="tagRight">
        {{ order.passengerName }}{{ order.passengerMobile }}
      </div>
    </div> -->
	<van-cell title="下单人" :value="order.passengerName+order.passengerMobile" />
    <van-cell is-link class="project">
      <template #title>
        <span>订单车辆</span>
        <van-tag class="tag" color="#9EA0A5">{{ order.carTypeName }}</van-tag>
      </template>
      <template #right-icon>
        <van-tag class="tagRight" color="rgba(255,149,0,0.1)">{{
          order.driverName
        }}</van-tag>
        <span class="spanRight">{{ order.carNumber }}</span>
      </template>
    </van-cell>
    <van-cell title="下单时间" :value="order.startTime" />
    <van-cell title="用车时间" :value="order.useCarTime" />
    <div class="happening">
      <p>乘车情况</p>
      <van-tabs v-model="show" type="card">
        <van-tab title="顺利完成"></van-tab>
        <van-tab title="不顺心">
          <van-checkbox-group
            v-model="select"
            style="font-size: 12px;padding: 15px;"
            direction="horizontal"
            @change="evaluation">
            <van-checkbox name="地址不好">地址不好 </van-checkbox>
            <van-checkbox name="等到时间长">等到时间长</van-checkbox>
            <van-checkbox name="乘车信息不准">乘车信息不准</van-checkbox>
          </van-checkbox-group></van-tab
        >
      </van-tabs>
    </div>
    <div class="happening">
      <p>服务态度评价</p>
      <van-tabbar
        v-model="active"
        :fixed="false"
        active-color="#ff9500"
        @change="checked"
      >
        <van-tabbar-item name="很差">
          <span>很差</span>
          <template #icon="props">
            <img :src="props.active ? icon.active : icon.inactive" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item name="一般">
          <span>一般</span >
          <template #icon="props">
            <img :src="props.active ? icon.active2 : icon.inactive2" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item name="很好">
          <span>很好</span>
          <template #icon="props">
            <img :src="props.active ? icon.active3 : icon.inactive3" />
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>
    <div class="happening">
      <p>驾驶技术评价</p>
      <van-tabbar
        v-model="technicalEvaluation"
        :fixed="false"
        active-color="#ff9500"
        @change="checkedTechnical"
      >
        <van-tabbar-item name="很差">
          <span>很差</span>
          <template #icon="props">
            <img :src="props.active ? icon.active : icon.inactive" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item name="一般">
          <span>一般</span>
          <template #icon="props">
            <img :src="props.active ? icon.active2 : icon.inactive2" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item  name="很好">
          <span>很好</span>
          <template #icon="props">
            <img :src="props.active ? icon.active3 : icon.inactive3" />
          </template>
        </van-tabbar-item>
      </van-tabbar>
      <van-field
        v-model="value"
        rows="1"
        autosize
        type="textarea"
        placeholder="请输入评价内容"
      />
    </div>
    <div class="happening">
      <van-button @click="submit" type="primary" color="rgba(33,37,41,1)" block
        >匿名提交
      </van-button>
    </div>
  </div>
</template>

<script>
import {
  Cell,
  NavBar,
  Tag,
  Tabbar,
  TabbarItem,
  Button,
  Dialog,
  Field,
  Tab,
  Tabs,
  Checkbox,
  CheckboxGroup
   
} from "vant";

export default {
  name: "assessSuccess",
  data() {
    return {
      // 选中乘车情况的评价
      selected: [],
      //   乘车情况的默认评价
      select: [],
	  returtlist:'',
      // 评价内容
      value: "",
      show: 0,
      order: [],
      accountid: localStorage.getItem("accountUid"),
	  sn: "",
      //   服务态度评价
      active:"很好",
      //   技术服务评价
      technicalEvaluation: "很好",
      icon: {
        active: require("@/assets/cp.png"),
        inactive: require("@/assets/cphui.png"),
        active2: require("@/assets/zp.png"),
        inactive2: require("@/assets/zphui.png"),
        active3: require("@/assets/hp.png"),
        inactive3: require("@/assets/hphui.png"),
      },
      curId: 0,
      items: [
        {
          item: "顺利完成",
        },
        {
          item: "不顺心",
        },
      ],
      contents: [
        {
          content: "地址不对",
        },
        {
          content: "等待时间长",
        },
        {
          content: "乘车信息不准确",
        },
      ],
    };
  },
  created() {
    this.sn=this.$route.params.sn;
    this.returtlist=this.$route.params.returtlist;
	this.snkey();
	this.orderDetail();
  },
  methods: {
	  
	  snkey(){
		  let orderSn =this.$Request.orderSn
		  if(this.sn==""||this.sn==null){
			   this.sn=orderSn
		  }
		 
	  },
	  onClickLeft() {
	  	if(this.returtlist==""||this.returtlist==null){
			window.open("app:/#/finish");
		}else{
			 this.$router.back();
		}
	    
	  },
    //态度评价
    checked() {
      console.log(this.active);
    },
    //技术服务评价
    checkedTechnical() {
      console.log(this.technicalEvaluation);
    },
    tab(index) {
      this.curId = index;
    },
	
    // 订单详情
    orderDetail() {
      this.$axios
        .get(
          `/vedm/orderCommonApp/getOrderDetail/${this.sn}/${this.accountid}`,
          {
            headers: {
              Authorization: localStorage.getItem("token"), //token换成从缓存获取
            },
          }
        )
        .then((res) => {
          console.log(res, "列表");
          this.order = res.data.data;
        }).catch(function (error) {
					    console.log(error)
					    window.app.showReLoginDialog()
				  });;
    },
    // 提交评价
    submit() {
   
		let datas=[]
		let arr={
			technicalEvaluation:this.technicalEvaluation,
			evaluationList:this.selected,
			active:this.active
    }
       // 提交的态度技术服务评价内容
		datas.push(arr)
      let data = {
        accountUid: this.accountid,
        createTime: this.order.createTime,
        createUser: this.createUser,
        delFlag: "",
        evaluationContent: '',
        evaluationList:JSON.stringify(datas),
        forbidden: '',
        id: "",
        orderSn: this.order.sn,
        remarks:	this.value,
        updateTime: this.order.updateTime,
        updateUser: this.order.updateUser,
      };
      this.$axios
        .post(`/vedm/eOrderApp/orderEvaluation/${this.sn}`, data, {
          headers: {
            Authorization: localStorage.getItem("token"), //token换成从缓存获取
          },
        })
        .then((res) => {
		  console.log(res, "评价");
		  if(res.data.code==0){
 Dialog({ message:"评价成功" }).then(()=>{
			window.history.go(-1)
			window.open("app:/#/finish");
		  });
		  }else{
			   Dialog({ message:"评价失败" }).then(()=>{
			  window.open("app:/#/finish");
		  });
		 
		  }
        });
    },
    // 乘车情况不顺心的评价
    evaluation(item) {
      this.selected = item;
      console.log(this.selected);
    },
  },

  components: {
    "van-cell": Cell,
    "van-tag": Tag,
    "van-tabbar": Tabbar,
    "van-tabbar-item": TabbarItem,
    "van-button": Button,
    "van-field": Field,
    "van-tab": Tab,
    "van-tabs": Tabs,
    "van-checkbox-group": CheckboxGroup,
    "van-checkbox": Checkbox,
	"van-nav-bar": NavBar,
    [Dialog.Component.name]: Dialog.Component,
  },
};
</script>

<style scoped lang="less">
.order {
  margin-left: 15px;
  display: flex;
  justify-content: space-between;
  background-color: white;
  font-size: 12px;
}
.assessSuccess {
  background: rgba(247, 247, 247, 1);
  .van-tabbar-item__icon img{
	  height: 30px;
  }
  .project {
    align-items: center;
    .number {
      display: block;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(158, 160, 165, 1);
    }

    .name {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(33, 37, 41, 1);
      margin: 0;
    }

    .tag {
      margin-left: 10px;
    }

    .tagRight {
      background: rgba(255, 149, 0, 0.1);
      border-radius: 2px;
      border: 1px solid rgba(255, 149, 0, 1);
      font-size: 11px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 149, 0, 1);
      margin-right: 5px;
    }

    .spanRight {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(33, 37, 41, 1);
    }
  }

  .happening {
    width: 375px;
    background: rgba(255, 255, 255, 1);
    padding: 15px;
    margin-bottom: 12px;

    p {
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(33, 37, 41, 1);
      margin: 0;
      margin-bottom: 20px;
    }

    .div {
      width: 104px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      border-radius: 14px;
      border: 1px solid rgba(232, 233, 235, 1);
      margin: 0 auto;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(33, 37, 41, 1);
      float: left;
      margin-left: 30px;
    }

    .options {
      width: 345px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 20px;
    }

    .item {
      height: 28px;
      line-height: 28px;
      text-align: center;
      border-radius: 6px;
      padding: 0 20px;
      border: 1px solid rgba(232, 233, 235, 1);
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(98, 104, 112, 1);
      margin-top: 10px;
    }
  }
}
</style>
